"use strict";const l=require("react");let e=0,o=null;const r=t=>{l.useEffect(()=>{if(t)return e===0&&(o=document.body.style.overflow),e+=1,document.body.style.overflow="hidden",()=>{e-=1,e===0&&(document.body.style.overflow=o??"",o=null)}},[t])};module.exports=r;
//# sourceMappingURL=useBodyScrollLock.js.map
